export class SignInWithoutPasswordError extends Error {
  public constructor() {
    super()

    this.message = 'errors.signInWithoutPassword'
  }
}
